// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const murphysLaw: Law = {
  slug: "murphys-law",
  title: "Murphy's Law",
  definition: "If something can go wrong, it will.",
  category: "theory",
  color: "#be9df7",
  labels: ["software-engineering","management"],
  takeaways: ["First derivation: If it works, you probably didn't write it.","Second derivation: Cursing is the only language all programmers speak fluently.","Conclusion: A computer will do what you write, not what you want."],
  copy: ["Probably one of the most famous of all laws, mostly because it is not only applicable to Software Development.","Defensive programming, version control, doom scenario's (for those damned zombie-server-attacks), TDD, MDD, etc. are all are good practices for defending against this law."],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
